import { RepairItemAmountField } from './repairItemAmountField';
import { RepairItemSelectEntryField } from './repairItemSelectEntryField';
import './repairItemSelectField.css';
import { InsuranceResultInfoType, RepairItemType } from '@/types/bodyAndPaint';

interface RepairItemSelectProps {
  onCheckImage: () => void;
  isInsurance: boolean;
  insurance: InsuranceResultInfoType;
  itemList: RepairItemType[];
  onChangeItem: ({ index, select }: { index: number; select: number }) => void;
  totalAmount: string;
  onRequest: () => void;
}
export const RepairItemSelectField = ({
  onCheckImage,
  isInsurance,
  insurance,
  itemList,
  onChangeItem,
  totalAmount,
  onRequest,
}: RepairItemSelectProps) => {
  return (
    <div className={'repair-item-select-field'}>
      <RepairItemSelectEntryField
        list={itemList}
        onChange={onChangeItem}
        onCheckImage={onCheckImage}
        isInsurance={isInsurance}
        insurance={insurance}
      />
      <RepairItemAmountField totalAmount={totalAmount} onClick={onRequest} />
    </div>
  );
};
